import { VzblTag } from "../../components/VzblTag";
import { EntityContext } from "../../useEntityContext";
import { IndicatorType, MetadataTag } from "src/components/MetadataTag";

export type HeaderAttribute = {
  value: string;
  label?: string;
  linkable?: boolean;
  child?: React.ReactElement;
};

export function toHeaderAttributes(props: {
  orgId: string;
  context: EntityContext;
  entityType: any;
  attributes: {
    name: string;
    text: string;
    type?: "status" | "issuetype" | "priority" | "metadata";
  }[];
}): HeaderAttribute[] {
  return props.attributes.map((attr) => ({
    value: attr.name,
    child: attr.type ? (
      <MetadataTag
        metadata={attr.text}
        type={attr.type as IndicatorType}
        size="medium"
        showLabel
      />
    ) : (
      <VzblTag
        asLink
        orgId={props.orgId}
        context={props.context}
        text={attr.text}
        linkParams={{
          orgId: props.orgId,
          entityType: props.entityType,
          attribute: attr.name,
          value: attr.text,
        }}
      />
    ),
  }));
}
